
export default {
  data() {
    return {
      options: [
        {
          name: "icon",
          label: this.$t("label.icon"),
          type: "image",
          size: "24x24",
        },
        {
          name: "link",
          label: this.$t("label.link"),
          type: "link",
        },
        {
          name: "description",
          label: this.$t("label.description"),
          type: "tipTap",
        },
      ],

      socialOptions: [
        {
          name: "icon",
          label: this.$t("label.icon"),
          type: "image",
          size: "24x24",
        },
        {
          name: "link",
          label: this.$t("label.link"),
          type: "link",
        },
      ],

      paymentOptions: [
        {
          name: "image",
          label: this.$t("label.image"),
          type: "image",
          size: "32x24",
        },
      ],
    };
  },
};
